/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { AppPermissionsEnum } from './AppPermissionsEnum';
import {
    instanceOfAppPermissionsEnum,
    AppPermissionsEnumFromJSON,
    AppPermissionsEnumFromJSONTyped,
    AppPermissionsEnumToJSON,
} from './AppPermissionsEnum';

/**
 * @type PermissionDtoParent
 * 
 * @export
 */
export type PermissionDtoParent = AppPermissionsEnum;


export function PermissionDtoParentFromJSON(json: any): PermissionDtoParent {
    return PermissionDtoParentFromJSONTyped(json, false);
}

export function PermissionDtoParentFromJSONTyped(json: any, ignoreDiscriminator: boolean): PermissionDtoParent {
    if (json == null) {
        return json;
    }
    // This is the original code, had to remove spread operator for const object enums that are not spreadable
    // return { ...AppPermissionsEnumFromJSONTyped(json, true) };
    return  AppPermissionsEnumFromJSONTyped(json, true);
}

export function PermissionDtoParentToJSON(value?: PermissionDtoParent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }

    if (instanceOfAppPermissionsEnum(value)) {
        return AppPermissionsEnumToJSON(value as AppPermissionsEnum);
    }

    return {};
}

/**
 * Check if a given object implements the PermissionDtoParent interface.
 */
export function instanceOfPermissionDtoParent(value: any): value is PermissionDtoParent {
    if (instanceOfAppPermissionsEnum(value)) return true;
    return false;
}

